import ActionTypes from '../../actionTypes'
const { GET_SUMMARY_SUCCESS, GET_SUMMARY_FAIL, GET_DETAILS_SUCCESS, GET_DETAILS_FAIL } = ActionTypes.REPORTS.CAN_PACKET_HEALTH

const initialState = {
  summary: null,
  details: null,
}

const canPacketHealthReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: payload,
      }
    case GET_SUMMARY_FAIL:
      return {
        ...state,
        summary: null,
      }
    case GET_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload,
      }
    case GET_DETAILS_FAIL:
      return {
        ...state,
        details: null,
      }
    default:
      return state
  }
}

export default canPacketHealthReducer
